import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { BENEFITS } from '../utils/constants';
export function ProductPresentation() {
  return <section className="bg-white py-16 px-4" data-id="element-236">
      <div className="max-w-7xl mx-auto" data-id="element-237">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-blue-900 mb-4" data-id="element-238">
          Ed è proprio per questo che abbiamo creato il Mega-Pack Yoga per
          Bambini
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12" data-id="element-239">
          Una raccolta completa di 5 risorse + 4 bonus gratuiti per trasformare
          ogni tua lezione in un'esperienza magica, educativa e indimenticabile.
        </p>

        <div className="bg-gradient-to-br from-blue-50 to-green-50 border border-blue-100 rounded-3xl p-8 md:p-12" data-id="element-240">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-241">
            {BENEFITS.map((benefit, index) => <div key={index} className="bg-white rounded-lg p-6 shadow-sm flex gap-4" data-id="element-242">
                <CheckCircle2Icon className="w-8 h-8 text-green-600 flex-shrink-0 mt-1" data-id="element-243" />
                <p className="text-lg text-gray-800" data-id="element-244">{benefit}</p>
              </div>)}
          </div>

          <p className="text-center text-xl text-gray-700 italic mt-8" data-id="element-245">
            Tutto quello che ti serve, in un'unica raccolta.
          </p>
        </div>
      </div>
    </section>;
}